import { render, staticRenderFns } from "./k-catalog-tree.vue?vue&type=template&id=1684a4a6&scoped=true&"
import script from "./k-catalog-tree.vue?vue&type=script&lang=ts&"
export * from "./k-catalog-tree.vue?vue&type=script&lang=ts&"
import style0 from "./k-catalog-tree.vue?vue&type=style&index=0&id=1684a4a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1684a4a6",
  null
  
)

export default component.exports